'use client';

import { Button } from '@kit/ui/button';
import { If } from '@kit/ui/if';
import { Trans } from '@kit/ui/trans';

interface AuthButtonProps {
  loading?: boolean;
  disabled?: boolean;
  type?: 'submit' | 'button';
  onClick?: () => void;
  children?: React.ReactNode;
  loadingText?: string;
  className?: string;
  'data-test'?: string;
}

export function AuthButton({
  loading,
  disabled,
  type = 'submit',
  onClick,
  children,
  loadingText,
  className,
  'data-test': dataTest,
}: AuthButtonProps) {
  return (
    <Button
      disabled={disabled ?? loading}
      type={type}
      onClick={onClick}
      data-test={dataTest}
      className={
        'flex h-[44px] w-full items-center justify-center gap-[8px] px-[18px] py-[4px] ' +
        'rounded-[62px] bg-[#dddddd] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10),_0px_1px_2px_-1px_rgba(0,0,0,0.10)] ' +
        'text-[14px] font-semibold leading-[20px] text-[#181618] ' +
        'hover:bg-[#ffffff] ' +
        (className ?? '')
      }
    >
      <If condition={loading} fallback={children}>
        {loadingText && <Trans i18nKey={loadingText} />}
      </If>
    </Button>
  );
}
